import api from './axiosConfig';

export const adminApi = {
  login: (email, password) => api.post('/v1/auth/login', { email, password }),
  getStats: () => api.get('/v1/admin/stats'),
  getRecentUsers: (limit = 10) => api.get(`/v1/admin/users/recent?limit=${limit}`),
  getAllUsers: (page = 1, limit = 10) => api.get(`/v1/admin/users?page=${page}&limit=${limit}`),
  getAllBusinesses: (page = 1, limit = 10) => api.get(`/v1/admin/businesses?page=${page}&limit=${limit}`),
  updateBusiness: (id, data) => api.put(`/v1/admin/businesses/${id}`, data),
  getAllProducts: (page = 1, limit = 10) => api.get(`/v1/admin/products?page=${page}&limit=${limit}`),
  getAllInvoices: (page = 1, limit = 10) => api.get(`/v1/admin/invoices?page=${page}&limit=${limit}`),
  getAllMails: (page = 1, limit = 10) => api.get(`/v1/admin/mails?page=${page}&limit=${limit}`),
  sendSystemMail: (data) => api.post('/v1/admin/mails/send', data),
  getAllStaff: (page = 1, limit = 10) => api.get(`/v1/admin/staff?page=${page}&limit=${limit}`),
  getAllEmployees: (page = 1, limit = 10) => api.get(`/v1/admin/employees?page=${page}&limit=${limit}`),
  getGrowthChart: () => api.get('/v1/admin/analytics/growth'),
  updateUserStatus: (id, isActive) => api.put(`/v1/admin/users/${id}/status`, { isActive }),
  createUser: (data) => api.post('/v1/admin/users', data),
  updateUser: (id, data) => api.put(`/v1/admin/users/${id}`, data),
  
  // Plans
  getPlans: () => api.get('/v1/subscription/admin/plans'),
  createPlan: (data) => api.post('/v1/subscription/plans', data),
  updatePlan: (id, data) => api.put(`/v1/subscription/plans/${id}`, data),
  deletePlan: (id) => api.delete(`/v1/subscription/plans/${id}`),

  // Exports
  exportUsers: () => api.get('/v1/admin/export/users', { responseType: 'blob' }),
  exportBusinesses: () => api.get('/v1/admin/export/businesses', { responseType: 'blob' }),
  exportInvoices: () => api.get('/v1/admin/export/invoices', { responseType: 'blob' }),

  // Settings
  getSettings: () => api.get('/v1/admin/settings'),
  updateSetting: (key, value) => api.put(`/v1/admin/settings/${key}`, { value }),

  // Audit Logs & Broadcast
  getAuditLogs: () => api.get('/v1/admin/audit-logs'),
  sendBroadcast: (data) => api.post('/v1/admin/broadcast', data),
  getBroadcastHistory: () => api.get('/v1/admin/broadcasts'),
  getBroadcastReaders: (id) => api.get(`/v1/admin/broadcasts/${id}/readers`),

  // Subscription Control
  overridePlan: (id, data) => api.post(`/v1/admin/users/${id}/override-plan`, data),

  // Platform Payments (Manual Approvals)
  getPlatformPayments: () => api.get('/v1/admin/platform-payments'),
  approveManualPayment: (id, status, remarks) => api.put(`/v1/admin/platform-payments/${id}/approve`, { status, remarks })
};
